import {gsap} from "gsap";

/**
 * Created by jonas on 2021-03-08.
 */

export class ReelDarkenPlate extends PIXI.Container{
    private plate:PIXI.Sprite;

    constructor() {
        super();

        this.plate = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.plate.tint = 0x000000;
        this.plate.alpha = 0.5;
        this.addChild(this.plate);
        this.alpha = 0;
    }

    public setReelSize(width:number, height:number){
        this.plate.width = width;
        this.plate.height = height;
    }


    public show(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this, {duration:duration, alpha:1}));
        return tl;
    }


    public hide(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this, {duration:duration, alpha:0}));
        return tl;
    }
}